import { render, staticRenderFns } from "./InvoiceItemDialog.vue?vue&type=template&id=6fa7e91e&scoped=true&"
import script from "./InvoiceItemDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItemDialog.vue?vue&type=style&index=0&id=6fa7e91e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7e91e",
  null
  
)

export default component.exports